// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* purgecss start ignore */\n.gallery-wrapper[data-v-a6aa1e4a]{\n  position:relative;\n  width:100%\n}\n\n/* purgecss end ignore */", ""]);
// Exports
module.exports = exports;
